export enum CertificationStatus {
	Pending = 0,
	Verified = 1,
	Unverified = 2
}
